import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=ee9171d4"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee9171d4')) {
      api.createRecord('ee9171d4', component.options)
    } else {
      api.reload('ee9171d4', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=ee9171d4", function () {
      api.rerender('ee9171d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Avatar.vue"
export default component.exports